export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9]+[a-zA-Z0-9-]*\.)+[a-zA-Z]{2,}))$/;
export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[/\W|_/g])[A-Za-z\d/\W|_/g]{8,}$/i;
export const PHONE_NUMBER_REGEX =
  /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i;
export const BASE_FONT_SIZE = 16;
export const IS_TOUCH_DEVICE = 'ontouchstart' in window || 'ontouch' in window;
